module.exports = __webpack_public_path__ + "media/styles/images/png/pen-gray-light-ee833caac5cd46b66e00b00f1bbbecd9.png";